import { lazy } from 'react'

export const AiTechV1 = lazy(() => import('./AiTechV1'))
